'use client';

import { Suspense } from 'react';
import type { Metadata } from 'next';
// Header provided by root layout
import BreadcrumbTrail from '@/components/common/BreadcrumbTrail';
import AIPlanInteractive from './components/AIPlanInteractive';
import Footer from '@/components/common/Footer';

const metadata: Metadata = {
  title: 'AI Plan - MicroSpace Optimizer',
  description: 'View your personalized space optimization plan with AI-generated recommendations, implementation timeline, and income projections.',
};

export default function AIPlanPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <main className="flex-1 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <BreadcrumbTrail />
        
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-foreground mb-2">
                Your AI-Generated Plan
              </h1>
              <p className="text-lg text-muted-foreground">
                Personalized recommendations for optimizing your space
              </p>
            </div>
            <div className="hidden sm:flex items-center space-x-2 text-sm text-muted-foreground">
              <div className="w-2 h-2 bg-success rounded-full"></div>
              <span>Plan ready</span>
            </div>
          </div>
        </div>

        <Suspense fallback={
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        }>
          <AIPlanInteractive />
        </Suspense>
      </main>

    </div>
  );
}